import { LuMenu } from "react-icons/lu";
import { Helmet } from "react-helmet";
import blueWave from "../../assets/blue_wave.mp4";
import { useIsUserSignedIn } from "../../core_stores/useAuthStore";
import {
  useIsSideMenuOpen,
  useSideMenuActions,
} from "../../view_stores/useSideMenuStore";
import { WelcomeAppBar } from "./components/WelcomeAppBar";
import { WelcomeDescription } from "./components/WelcomeDescription";
import { WelcomeFooter } from "./components/WelcomeFooter";
import WelcomeFreeToTryInfo from "./components/WelcomeFreeToTryInfo";
import { WelcomeBlogFeed } from "./components/WelcomeBlogFeed";
import { WelcomeTextField } from "./components/WelcomeTextField";

export function WelcomePageCompact() {
  const { open: openSideMenu, close: closeSideMenu } = useSideMenuActions();
  const isSideMenuOpen = useIsSideMenuOpen();
  const isUserSignedIn = useIsUserSignedIn();

  return (
    <>
      <Helmet>
        <title>Darvin - AI-Powered No-Code Flutter Mobile App Builder from Text</title>
      </Helmet>
      <div className="flex flex-col h-[100dvh] min-w-[350px]">
      <div
        className="flex-1 flex flex-col min-h-[660px] relative 
      overflow-hidden"
      >
        <video
          src={blueWave}
          autoPlay
          loop
          muted
          playsInline
          preload="auto"
          className="absolute right-0 top-0 w-full h-full object-cover scale-[1.1]"
        />
        <div
          className="absolute inset-0 bg-gradient-to-t 
              from-light-surface-primary dark:from-dark-surface-primary via-[#03142800] 
              to-transparent pointer-events-none"
        />
      </div>
      <div className="bg-light-surface-primary dark:bg-dark-surface-primary min-h-[420px]" />
      <div className="absolute inset-0">
        {/* <WelcomePromoCode /> */}
        <div className="flex flex-row items-center w-full z-10">
          {isUserSignedIn && (
            <div className="pl-4">
              <LuMenu
                size={34}
                onClick={isSideMenuOpen ? closeSideMenu : openSideMenu}
                className="cursor-pointer text-white"
              />
            </div>
          )}
          <WelcomeAppBar />
        </div>
        <div
          className="flex-1 flex flex-col items-center justify-center 
        gap-4 pt-4 pb-10 z-30"
        >
          <div className="w-full flex flex-col items-center justify-center gap-8">
            <div className="flex flex-col items-center justify-center gap-6">
              <WelcomeDescription />
            </div>
            <WelcomeTextField />
          </div>
          <WelcomeFreeToTryInfo />
          <div className="px-8 py-4 w-full space-y-4">
            {/* <WelcomeTryOutIdeas /> */}
            <WelcomeBlogFeed />
          </div>
        </div>
      </div>
      <WelcomeFooter />
    </div>
    </>
  );
}
